"use strict";
var Observable_1 = require('../../Observable');
var timeoutWith_1 = require('../../operator/timeoutWith');
Observable_1.Observable.prototype.timeoutWith = timeoutWith_1.timeoutWith;
//# sourceMappingURL=timeoutWith.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/add/operator/timeoutWith.js
// module id = 1025
// module chunks = 103